import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getCompanyById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/company/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/company/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyById.paramsOrder = [{ type: 'parameters' }];
export const getCompaniesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyIds === undefined) {
        throw new Error('Missing required body: companyIds');
    }
    const path = '/api/ws-companies/company/by-ids';
    const pathInternal = '/api/company/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyIds !== undefined) {
        body = params.companyIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompaniesByIds.paramsOrder = [{ type: 'body', paramName: 'companyIds' }];
export const fetchTemplateByTypeWithReplacedPlaceholders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/company/{companyId}/email-templates/{type}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/{companyId}/email-templates/{type}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    if (params.placeholderValues !== undefined) {
        body = params.placeholderValues;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
fetchTemplateByTypeWithReplacedPlaceholders.paramsOrder = [
    { type: 'body', paramName: 'placeholderValues' },
    { type: 'parameters' },
];
export const fetchLocalizedTemplateByTypeWithReplacedPlaceholders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/company/{companyId}/email-templates/{type}/localized'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/{companyId}/email-templates/{type}/localized'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    if (params.placeholderValues !== undefined) {
        body = params.placeholderValues;
    }
    {
        const value = queryDefaults === false ? params.languageCode : (params.languageCode ?? queryDefaults?.['languageCode']);
        if (value !== undefined) {
            urlParams.append('languageCode', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.formOfCommunication
            : (params.formOfCommunication ?? queryDefaults?.['formOfCommunication']);
        if (value !== undefined) {
            urlParams.append('formOfCommunication', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
fetchLocalizedTemplateByTypeWithReplacedPlaceholders.paramsOrder = [
    { type: 'body', paramName: 'placeholderValues' },
    { type: 'parameters' },
];
export const updateCompanyPaymentSettings = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/company/{companyId}/payment-settings'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/company/{companyId}/payment-settings'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.paymentSettingsValues !== undefined) {
        body = params.paymentSettingsValues;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyPaymentSettings.paramsOrder = [
    { type: 'body', paramName: 'paymentSettingsValues' },
    { type: 'parameters' },
];
export const getCompanyPaymentSettings = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/company/{companyId}/payment-settings'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/company/{companyId}/payment-settings'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPaymentSettings.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPdfStyle = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf/style';
    const pathInternal = '/api/company/pdf/style';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isMainLayout : (params.isMainLayout ?? queryDefaults?.['isMainLayout']);
        if (value !== undefined) {
            urlParams.append('isMainLayout', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfStyle.paramsOrder = [{ type: 'parameters' }];
export const saveCompanyPdfStyle = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pdfStyle === undefined) {
        throw new Error('Missing required body: pdfStyle');
    }
    const path = '/api/ws-companies/company/pdf/style';
    const pathInternal = '/api/company/pdf/style';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.pdfStyle !== undefined) {
        body = params.pdfStyle;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
saveCompanyPdfStyle.paramsOrder = [{ type: 'body', paramName: 'pdfStyle' }];
export const getCompanyPdfStyleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf/style/config';
    const pathInternal = '/api/company/pdf/style/config';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfStyleConfig.paramsOrder = [{ type: 'parameters' }];
export const updateCompanyPdfStyleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/company/pdf/style/config';
    const pathInternal = '/api/company/pdf/style/config';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyPdfStyleConfig.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const getCompanyPptStyle = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/company/ppt/style';
    const pathInternal = '/api/company/ppt/style';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPptStyle.paramsOrder = [{ type: 'parameters' }];
export const saveCompanyPptStyle = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pdfStyle === undefined) {
        throw new Error('Missing required body: pdfStyle');
    }
    const path = '/api/ws-companies/company/ppt/style';
    const pathInternal = '/api/company/ppt/style';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.pdfStyle !== undefined) {
        body = params.pdfStyle;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
saveCompanyPptStyle.paramsOrder = [{ type: 'body', paramName: 'pdfStyle' }];
export const getCompanyPptLogoFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/company/ppt/logo';
    const pathInternal = '/api/company/ppt/logo';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPptLogoFile.paramsOrder = [{ type: 'parameters' }];
export const uploadCompanyPptLogo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/company/ppt/upload-logo';
    const pathInternal = '/api/company/ppt/upload-logo';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    if (params.logo !== undefined) {
        formData.append('logo', toCorrectFormDataValue(params.logo));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadCompanyPptLogo.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getCompanyPptCommentTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/company/ppt-comment-template/{companyId}'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/company/ppt-comment-template/{companyId}'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPptCommentTemplate.paramsOrder = [{ type: 'parameters' }];
export const updateCompanyPptCommentTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/company/ppt-comment-template/{companyId}'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/company/ppt-comment-template/{companyId}'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCompanyPptCommentTemplate.paramsOrder = [
    { type: 'body', paramName: 'template' },
    { type: 'parameters' },
];
export const createCompanyPptCommentTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/company/ppt-comment-template';
    const pathInternal = '/api/company/ppt-comment-template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyPptCommentTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }];
export const getCompanyPdfTypeConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf/type/configs';
    const pathInternal = '/api/company/pdf/type/configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfTypeConfigs.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPdfTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/company/pdf/{type}/configs'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/pdf/{type}/configs'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfTypeConfig.paramsOrder = [{ type: 'parameters' }];
export const saveCompanyPdfTypeRowConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.rowConfig === undefined) {
        throw new Error('Missing required body: rowConfig');
    }
    const path = '/api/ws-companies/company/pdf/configs/{type}/row'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/pdf/configs/{type}/row'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    if (params.rowConfig !== undefined) {
        body = params.rowConfig;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
saveCompanyPdfTypeRowConfig.paramsOrder = [{ type: 'body', paramName: 'rowConfig' }, { type: 'parameters' }];
/** Returns a list with all templates for each sales unit */ export const getCompanyEmailTemplatesWithAllSalesUnits = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/email-templates/all';
    const pathInternal = '/api/email-templates/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyEmailTemplatesWithAllSalesUnits.paramsOrder = [];
/** Returns a list of templates for specific or default sales unit */ export const getCompanyEmailTemplates = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/email-templates';
    const pathInternal = '/api/email-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyEmailTemplates.paramsOrder = [{ type: 'parameters' }];
export const createCompanyEmailTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/email-templates';
    const pathInternal = '/api/email-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyEmailTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }];
export const getDefaultTemplateByType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/email-templates/default/{type}'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/email-templates/default/{type}'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDefaultTemplateByType.paramsOrder = [{ type: 'parameters' }];
export const getCompanyEmailTemplateById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.mailId === undefined) {
        throw new Error('Missing required parameter: mailId');
    }
    const path = '/api/ws-companies/email-templates/{mailId}'.replace('{mailId}', params.mailId?.toString());
    const pathInternal = '/api/email-templates/{mailId}'.replace('{mailId}', params.mailId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyEmailTemplateById.paramsOrder = [{ type: 'parameters' }];
export const updateEmailTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.mailId === undefined) {
        throw new Error('Missing required parameter: mailId');
    }
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/email-templates/{mailId}'.replace('{mailId}', params.mailId?.toString());
    const pathInternal = '/api/email-templates/{mailId}'.replace('{mailId}', params.mailId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateEmailTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }, { type: 'parameters' }];
/** Returns the email design of each sales unit of the current company */ export const getEmailDesigns = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/email-designs';
    const pathInternal = '/api/email-designs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailDesigns.paramsOrder = [];
export const getEmailDesignBySalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    const path = '/api/ws-companies/email-designs/by-sales-unit/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    const pathInternal = '/api/email-designs/by-sales-unit/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailDesignBySalesUnit.paramsOrder = [{ type: 'parameters' }];
/** Creates or updates the email design of a sales unit */ export const upsertEmailDesignBySalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    if (params.design === undefined) {
        throw new Error('Missing required body: design');
    }
    const path = '/api/ws-companies/email-designs/by-sales-unit/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    const pathInternal = '/api/email-designs/by-sales-unit/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.design !== undefined) {
        body = params.design;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertEmailDesignBySalesUnit.paramsOrder = [{ type: 'body', paramName: 'design' }, { type: 'parameters' }];
export const getCompanyPdfFooterTemplateByType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/company/{companyId}/pdf-footer-templates/{type}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/{companyId}/pdf-footer-templates/{type}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfFooterTemplateByType.paramsOrder = [{ type: 'parameters' }];
export const getCompanyPdfFooterPermittedTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf-footer-permitted-types';
    const pathInternal = '/api/company/pdf-footer-permitted-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfFooterPermittedTypes.paramsOrder = [];
export const getCompanyPdfFooterTemplates = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf-footer-templates';
    const pathInternal = '/api/company/pdf-footer-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyPdfFooterTemplates.paramsOrder = [{ type: 'parameters' }];
export const createCompanyPdfFooterTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/company/pdf-footer-templates';
    const pathInternal = '/api/company/pdf-footer-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyPdfFooterTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }];
export const updatePdfFooterTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pdfTemplateId === undefined) {
        throw new Error('Missing required parameter: pdfTemplateId');
    }
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    const path = '/api/ws-companies/pdf-footer-templates/{pdfTemplateId}'.replace('{pdfTemplateId}', params.pdfTemplateId?.toString());
    const pathInternal = '/api/pdf-footer-templates/{pdfTemplateId}'.replace('{pdfTemplateId}', params.pdfTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePdfFooterTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }, { type: 'parameters' }];
/** Create pdf appendix from ws-file-uploader file */ export const createPdfAppendix = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/pdf-appendixes';
    const pathInternal = '/api/pdf-appendixes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPdfAppendix.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get pfd-appendix */ export const getPdfAppendixFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/pdf-appendixes/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/pdf-appendixes/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPdfAppendixFile.paramsOrder = [{ type: 'parameters' }];
/** Delete pdf appendix file */ export const deletePdfAppendixFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/pdf-appendixes/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/pdf-appendixes/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deletePdfAppendixFile.paramsOrder = [{ type: 'parameters' }];
/** Get company logo file */ export const getCompanyLogoFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/logo';
    const pathInternal = '/api/company/logo';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.id : (params.id ?? queryDefaults?.['id']);
        if (value !== undefined) {
            urlParams.append('id', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyLogoFile.paramsOrder = [{ type: 'parameters' }];
export const getAdminCompany = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/admin';
    const pathInternal = '/api/company/admin';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdminCompany.paramsOrder = [];
export const getCompanyByUserId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    const path = '/api/ws-companies/company/user.id/{userId}'.replace('{userId}', params.userId?.toString());
    const pathInternal = '/api/company/user.id/{userId}'.replace('{userId}', params.userId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyByUserId.paramsOrder = [{ type: 'parameters' }];
export const getUserById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/user/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserById.paramsOrder = [{ type: 'parameters' }];
export const getUsersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-companies/user/by-ids';
    const pathInternal = '/api/user/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUsersByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getCurrentUserProfile = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/user/current-user-profile';
    const pathInternal = '/api/user/current-user-profile';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCurrentUserProfile.paramsOrder = [];
export const changeUserPassword = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/user/password';
    const pathInternal = '/api/user/password';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
changeUserPassword.paramsOrder = [{ type: 'body', paramName: 'form' }];
export const disableUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/user/{id}/disable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user/{id}/disable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
disableUser.paramsOrder = [{ type: 'parameters' }];
export const enableUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/user/{id}/enable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user/{id}/enable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enableUser.paramsOrder = [{ type: 'parameters' }];
export const getUserByEmail = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-companies/user/by-email';
    const pathInternal = '/api/user/by-email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserByEmail.paramsOrder = [{ type: 'parameters' }];
export const getUsersByCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/user/company.id/{companyId}'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/user/company.id/{companyId}'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUsersByCompanyId.paramsOrder = [{ type: 'parameters' }];
export const getUsersByPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userByPositionForm === undefined) {
        throw new Error('Missing required body: userByPositionForm');
    }
    const path = '/api/ws-companies/user/by-company-position';
    const pathInternal = '/api/user/by-company-position';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.contactId : (params.contactId ?? queryDefaults?.['contactId']);
        if (value !== undefined) {
            urlParams.append('contactId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    if (params.userByPositionForm !== undefined) {
        body = params.userByPositionForm;
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUsersByPositions.paramsOrder = [{ type: 'body', paramName: 'userByPositionForm' }, { type: 'parameters' }];
export const getUsers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/user';
    const pathInternal = '/api/user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortDirection : (params.sortDirection ?? queryDefaults?.['sortDirection']);
        if (value !== undefined) {
            urlParams.append('sortDirection', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortProperties : (params.sortProperties ?? queryDefaults?.['sortProperties']);
        if (value !== undefined) {
            urlParams.append('sortProperties', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.onlySales : (params.onlySales ?? queryDefaults?.['onlySales']);
        if (value !== undefined) {
            urlParams.append('onlySales', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.hasContact : (params.hasContact ?? queryDefaults?.['hasContact']);
        if (value !== undefined) {
            urlParams.append('hasContact', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUsers.paramsOrder = [{ type: 'parameters' }];
export const updateUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.user === undefined) {
        throw new Error('Missing required body: user');
    }
    const path = '/api/ws-companies/user';
    const pathInternal = '/api/user';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    if (params.user !== undefined) {
        body = params.user;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateUser.paramsOrder = [{ type: 'body', paramName: 'user' }, { type: 'parameters' }];
export const createUserAsAdmin = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.user === undefined) {
        throw new Error('Missing required body: user');
    }
    const path = '/api/ws-companies/user/admin';
    const pathInternal = '/api/user/admin';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.user !== undefined) {
        body = params.user;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createUserAsAdmin.paramsOrder = [{ type: 'body', paramName: 'user' }];
export const updateUserAsAdmin = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.user === undefined) {
        throw new Error('Missing required body: user');
    }
    const path = '/api/ws-companies/user/admin';
    const pathInternal = '/api/user/admin';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    if (params.user !== undefined) {
        body = params.user;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateUserAsAdmin.paramsOrder = [{ type: 'body', paramName: 'user' }, { type: 'parameters' }];
export const setUserContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/user/admin/{id}/set-contact'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/user/admin/{id}/set-contact'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.contactId : (params.contactId ?? queryDefaults?.['contactId']);
        if (value !== undefined) {
            urlParams.append('contactId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setUserContact.paramsOrder = [{ type: 'parameters' }];
/** Returns sales contacts visible to the current user */ export const getSalesContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/sales-contacts';
    const pathInternal = '/api/sales-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesContacts.paramsOrder = [{ type: 'parameters' }];
export const getCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company';
    const pathInternal = '/api/company';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortDirection : (params.sortDirection ?? queryDefaults?.['sortDirection']);
        if (value !== undefined) {
            urlParams.append('sortDirection', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortProperties : (params.sortProperties ?? queryDefaults?.['sortProperties']);
        if (value !== undefined) {
            urlParams.append('sortProperties', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanies.paramsOrder = [{ type: 'parameters' }];
export const getCompanyNamesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-companies/company/names/by-ids';
    const pathInternal = '/api/company/names/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyNamesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getInvoiceInfos = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/invoice-infos';
    const pathInternal = '/api/invoice-infos';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfos.paramsOrder = [];
export const createInvoiceInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceInfo === undefined) {
        throw new Error('Missing required body: invoiceInfo');
    }
    const path = '/api/ws-companies/invoice-infos';
    const pathInternal = '/api/invoice-infos';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceInfo !== undefined) {
        body = params.invoiceInfo;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createInvoiceInfo.paramsOrder = [{ type: 'body', paramName: 'invoiceInfo' }];
export const getInvoiceInfoById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/invoice-infos/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoice-infos/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfoById.paramsOrder = [{ type: 'parameters' }];
export const updateInvoiceInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.invoiceInfo === undefined) {
        throw new Error('Missing required body: invoiceInfo');
    }
    const path = '/api/ws-companies/invoice-infos/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoice-infos/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceInfo !== undefined) {
        body = params.invoiceInfo;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateInvoiceInfo.paramsOrder = [{ type: 'body', paramName: 'invoiceInfo' }, { type: 'parameters' }];
export const getInvoiceInfosByCompanyIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required body: companyId');
    }
    const path = '/api/ws-companies/invoice-infos/companies';
    const pathInternal = '/api/invoice-infos/companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        body = params.companyId;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfosByCompanyIds.paramsOrder = [{ type: 'body', paramName: 'companyId' }];
export const getInvoiceInfosWithDefaultSalesUnitId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/invoice-infos/companies/{companyId}/default-sales-unit'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/invoice-infos/companies/{companyId}/default-sales-unit'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfosWithDefaultSalesUnitId.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceInfosBySalesUnitId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    const path = '/api/ws-companies/invoice-infos/companies/{companyId}/sales-units/{salesUnitId}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{salesUnitId}', params.salesUnitId?.toString());
    const pathInternal = '/api/invoice-infos/companies/{companyId}/sales-units/{salesUnitId}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{salesUnitId}', params.salesUnitId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfosBySalesUnitId.paramsOrder = [{ type: 'parameters' }];
export const getInvoiceInfosBySalesUnitIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnitIds === undefined) {
        throw new Error('Missing required body: salesUnitIds');
    }
    const path = '/api/ws-companies/invoice-infos/sales-units';
    const pathInternal = '/api/invoice-infos/sales-units';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesUnitIds !== undefined) {
        body = params.salesUnitIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfosBySalesUnitIds.paramsOrder = [{ type: 'body', paramName: 'salesUnitIds' }];
export const getInvoiceInfoByCurrency = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    if (params.currency === undefined) {
        throw new Error('Missing required parameter: currency');
    }
    const path = '/api/ws-companies/invoice-infos/companies/{companyId}/sales-units/{salesUnitId}/currencies/{currency}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{salesUnitId}', params.salesUnitId?.toString())
        .replace('{currency}', params.currency?.toString());
    const pathInternal = '/api/invoice-infos/companies/{companyId}/sales-units/{salesUnitId}/currencies/{currency}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{salesUnitId}', params.salesUnitId?.toString())
        .replace('{currency}', params.currency?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceInfoByCurrency.paramsOrder = [{ type: 'parameters' }];
export const getUserRoles = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/user/roles';
    const pathInternal = '/api/user/roles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserRoles.paramsOrder = [];
export const getUserToActivate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.key === undefined) {
        throw new Error('Missing required parameter: key');
    }
    const path = '/api/ws-companies/public/users/activate/{key}'.replace('{key}', params.key?.toString());
    const pathInternal = '/api/public/users/activate/{key}'.replace('{key}', params.key?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getUserToActivate.paramsOrder = [{ type: 'parameters' }];
export const processActivateUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.user === undefined) {
        throw new Error('Missing required body: user');
    }
    if (params.key === undefined) {
        throw new Error('Missing required parameter: key');
    }
    const path = '/api/ws-companies/public/users/activate/{key}'.replace('{key}', params.key?.toString());
    const pathInternal = '/api/public/users/activate/{key}'.replace('{key}', params.key?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.user !== undefined) {
        body = params.user;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
processActivateUser.paramsOrder = [{ type: 'body', paramName: 'user' }, { type: 'parameters' }];
export const restorePassword = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-companies/user/restore-password';
    const pathInternal = '/api/user/restore-password';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
restorePassword.paramsOrder = [{ type: 'parameters' }];
export const changePasswordUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.key === undefined) {
        throw new Error('Missing required parameter: key');
    }
    const path = '/api/ws-companies/public/users/change-password';
    const pathInternal = '/api/public/users/change-password';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.key !== undefined) {
        urlParams.append('key', params.key.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePasswordUser.paramsOrder = [{ type: 'parameters' }];
export const changePassword = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.key === undefined) {
        throw new Error('Missing required parameter: key');
    }
    if (params.password === undefined) {
        throw new Error('Missing required parameter: password');
    }
    if (params.repeatedPassword === undefined) {
        throw new Error('Missing required parameter: repeatedPassword');
    }
    const path = '/api/ws-companies/public/users/change-password';
    const pathInternal = '/api/public/users/change-password';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.key !== undefined) {
        urlParams.append('key', params.key.toString());
    }
    if (params.password !== undefined) {
        urlParams.append('password', params.password.toString());
    }
    if (params.repeatedPassword !== undefined) {
        urlParams.append('repeatedPassword', params.repeatedPassword.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changePassword.paramsOrder = [{ type: 'parameters' }];
export const logRegistrationAttempt = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/public/users/log-uncompleted-registration-attempt';
    const pathInternal = '/api/public/users/log-uncompleted-registration-attempt';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
logRegistrationAttempt.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Creates company with SB permission, user and account */ export const createPromoUserData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/public/promo';
    const pathInternal = '/api/public/promo';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPromoUserData.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get base available company info without permissions check */ export const getCompanyBaseData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/companies/{companyId}/base-info'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/base-info'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyBaseData.paramsOrder = [{ type: 'parameters' }];
export const createContactFromUser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-companies/admin/users/{userId}/contact'.replace('{userId}', params.userId?.toString());
    const pathInternal = '/api/admin/users/{userId}/contact'.replace('{userId}', params.userId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createContactFromUser.paramsOrder = [{ type: 'parameters' }];
/** Get all companies */ export const getAllCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/admin/companies';
    const pathInternal = '/api/admin/companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllCompanies.paramsOrder = [{ type: 'parameters' }];
export const createCompanyByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyName === undefined) {
        throw new Error('Missing required parameter: companyName');
    }
    const path = '/api/ws-companies/admin/companies/create/by-name';
    const pathInternal = '/api/admin/companies/create/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyName !== undefined) {
        urlParams.append('companyName', params.companyName.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyByName.paramsOrder = [{ type: 'parameters' }];
export const createCompanyByAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-companies/admin/companies/create/by-account';
    const pathInternal = '/api/admin/companies/create/by-account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCompanyByAccount.paramsOrder = [{ type: 'parameters' }];
export const editCompanyFromAdmin = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.company === undefined) {
        throw new Error('Missing required body: company');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/admin/companies/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/admin/companies/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.company !== undefined) {
        body = params.company;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editCompanyFromAdmin.paramsOrder = [{ type: 'body', paramName: 'company' }, { type: 'parameters' }];
export const inviteContactToConsole = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    if (params.role === undefined) {
        throw new Error('Missing required parameter: role');
    }
    if (params.adminId === undefined) {
        throw new Error('Missing required parameter: adminId');
    }
    const path = '/api/ws-companies/admin/companies/{companyId}/contacts/{contactId}/invite'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{contactId}', params.contactId?.toString());
    const pathInternal = '/api/admin/companies/{companyId}/contacts/{contactId}/invite'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{contactId}', params.contactId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.role !== undefined) {
        urlParams.append('role', params.role.toString());
    }
    if (params.adminId !== undefined) {
        urlParams.append('adminId', params.adminId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
inviteContactToConsole.paramsOrder = [{ type: 'parameters' }];
export const getCompany = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/companies/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/companies/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompany.paramsOrder = [{ type: 'parameters' }];
export const editCompanyFromAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.company === undefined) {
        throw new Error('Missing required body: company');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/companies/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/companies/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.company !== undefined) {
        body = params.company;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
editCompanyFromAccount.paramsOrder = [{ type: 'body', paramName: 'company' }, { type: 'parameters' }];
export const uploadCompanyLogo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/companies/upload-logo';
    const pathInternal = '/api/companies/upload-logo';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.id : (params.id ?? queryDefaults?.['id']);
        if (value !== undefined) {
            urlParams.append('id', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    if (params.logo !== undefined) {
        formData.append('logo', toCorrectFormDataValue(params.logo));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadCompanyLogo.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getCompanyUsers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/companies/{id}/users'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/companies/{id}/users'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyUsers.paramsOrder = [{ type: 'parameters' }];
export const inviteUserToCompany = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    if (params.role === undefined) {
        throw new Error('Missing required parameter: role');
    }
    if (params.adminId === undefined) {
        throw new Error('Missing required parameter: adminId');
    }
    const path = '/api/ws-companies/companies/{companyId}/users/invite'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/users/invite'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    if (params.role !== undefined) {
        urlParams.append('role', params.role.toString());
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    if (params.adminId !== undefined) {
        urlParams.append('adminId', params.adminId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
inviteUserToCompany.paramsOrder = [{ type: 'parameters' }];
export const getTokenByInvitationCode = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.userId === undefined) {
        throw new Error('Missing required parameter: userId');
    }
    if (params.invitationCode === undefined) {
        throw new Error('Missing required parameter: invitationCode');
    }
    const path = '/api/ws-companies/token';
    const pathInternal = '/api/token';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.userId !== undefined) {
        urlParams.append('userId', params.userId.toString());
    }
    if (params.invitationCode !== undefined) {
        urlParams.append('invitationCode', params.invitationCode.toString());
    }
    {
        const value = queryDefaults === false
            ? params.keepInvitationCode
            : (params.keepInvitationCode ?? queryDefaults?.['keepInvitationCode']);
        if (value !== undefined) {
            urlParams.append('keepInvitationCode', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTokenByInvitationCode.paramsOrder = [{ type: 'parameters' }];
export const generateToken = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.credential === undefined) {
        throw new Error('Missing required body: credential');
    }
    const path = '/api/ws-companies/token';
    const pathInternal = '/api/token';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.credential !== undefined) {
        body = params.credential;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: { 200: 'json', 204: 'void' },
        requestType: 'json',
    });
};
generateToken.paramsOrder = [{ type: 'body', paramName: 'credential' }];
export const confirm = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.confirmationCode === undefined) {
        throw new Error('Missing required body: confirmationCode');
    }
    const path = '/api/ws-companies/confirm';
    const pathInternal = '/api/confirm';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.confirmationCode !== undefined) {
        body = params.confirmationCode;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
confirm.paramsOrder = [{ type: 'body', paramName: 'confirmationCode' }];
export const getAuthorizationUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.idp === undefined) {
        throw new Error('Missing required parameter: idp');
    }
    const path = '/api/ws-companies/openid/authorization-url';
    const pathInternal = '/api/openid/authorization-url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.idp !== undefined) {
        urlParams.append('idp', params.idp.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAuthorizationUrl.paramsOrder = [{ type: 'parameters' }];
export const exchangeAuthorizationCode = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.idp === undefined) {
        throw new Error('Missing required parameter: idp');
    }
    if (params.code === undefined) {
        throw new Error('Missing required parameter: code');
    }
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-companies/openid/{idp}/exchange-code'.replace('{idp}', params.idp?.toString());
    const pathInternal = '/api/openid/{idp}/exchange-code'.replace('{idp}', params.idp?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.code !== undefined) {
        urlParams.append('code', params.code.toString());
    }
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
exchangeAuthorizationCode.paramsOrder = [{ type: 'parameters' }];
export const exchangeToken = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.openidToken === undefined) {
        throw new Error('Missing required body: openidToken');
    }
    const path = '/api/ws-companies/openid/exchange-token';
    const pathInternal = '/api/openid/exchange-token';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.openidToken !== undefined) {
        body = params.openidToken;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
exchangeToken.paramsOrder = [{ type: 'body', paramName: 'openidToken' }];
export const getMailTemplatePlaceholders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/mail-templates/placeholders';
    const pathInternal = '/api/mail-templates/placeholders';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMailTemplatePlaceholders.paramsOrder = [{ type: 'parameters' }];
/** Returns users */ export const getBatchUsers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-companies/batch/users';
    const pathInternal = '/api/batch/users';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchUsers.paramsOrder = [{ type: 'parameters' }];
/** Returns companies */ export const getBatchCompanies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-companies/batch/companies';
    const pathInternal = '/api/batch/companies';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCompanies.paramsOrder = [{ type: 'parameters' }];
/** Returns salesUnits */ export const getBatchSalesUnits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-companies/batch/sales-units';
    const pathInternal = '/api/batch/sales-units';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchSalesUnits.paramsOrder = [{ type: 'parameters' }];
/** Returns currencies by company ID */ export const getCompanyCurrencies = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/companies/{companyId}/currencies'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/currencies'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyCurrencies.paramsOrder = [{ type: 'parameters' }];
/** Returns country vat rate by company ID */ export const getCompanyVatRate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.country === undefined) {
        throw new Error('Missing required parameter: country');
    }
    const path = '/api/ws-companies/companies/{companyId}/vat-rate/{country}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{country}', params.country?.toString());
    const pathInternal = '/api/companies/{companyId}/vat-rate/{country}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{country}', params.country?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.date : (params.date ?? queryDefaults?.['date']);
        if (value !== undefined) {
            urlParams.append('date', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyVatRate.paramsOrder = [{ type: 'parameters' }];
/** Returns all company vat rates */ export const getAllCompanyVatRates = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/companies/{companyId}/all-vat-rates'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/all-vat-rates'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllCompanyVatRates.paramsOrder = [{ type: 'parameters' }];
/** Returns true if domestic vat country */ export const isDomesticVatCountry = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.countryCode === undefined) {
        throw new Error('Missing required parameter: countryCode');
    }
    const path = '/api/ws-companies/companies/{companyId}/is-domestic-vat-country/{countryCode}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{countryCode}', params.countryCode?.toString());
    const pathInternal = '/api/companies/{companyId}/is-domestic-vat-country/{countryCode}'
        .replace('{companyId}', params.companyId?.toString())
        .replace('{countryCode}', params.countryCode?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
isDomesticVatCountry.paramsOrder = [{ type: 'parameters' }];
/** Returns additional tax percentage by company ID */ export const getCompanyAdditionalTaxPercentage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/companies/{companyId}/additional-tax-percentage'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/companies/{companyId}/additional-tax-percentage'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.date : (params.date ?? queryDefaults?.['date']);
        if (value !== undefined) {
            urlParams.append('date', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyAdditionalTaxPercentage.paramsOrder = [{ type: 'parameters' }];
/** Get discount by id */ export const getCompanyDiscount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/companies/discounts/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/companies/discounts/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyDiscount.paramsOrder = [{ type: 'parameters' }];
/** Get list of discounts of the company */ export const getCompanyDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/companies/discounts';
    const pathInternal = '/api/companies/discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.search : (params.search ?? queryDefaults?.['search']);
        if (value !== undefined) {
            urlParams.append('search', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyDiscounts.paramsOrder = [{ type: 'parameters' }];
/** Create or update company discounts */ export const createOrUpdateCompanyDiscount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/companies/discounts';
    const pathInternal = '/api/companies/discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateCompanyDiscount.paramsOrder = [{ type: 'body', paramName: 'body' }];
/** Get list of discounts by ids */ export const getCompanyDiscountsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/companies/discounts/by-ids';
    const pathInternal = '/api/companies/discounts/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyDiscountsByIds.paramsOrder = [{ type: 'body', paramName: 'body' }];
export const getSalesUnitsBatch = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-companies/sales-units/batch';
    const pathInternal = '/api/sales-units/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesUnitsBatch.paramsOrder = [{ type: 'parameters' }];
export const getCompanySalesUnits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/admin/companies/sales-units';
    const pathInternal = '/api/admin/companies/sales-units';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanySalesUnits.paramsOrder = [{ type: 'parameters' }];
export const createSalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnit === undefined) {
        throw new Error('Missing required body: salesUnit');
    }
    const path = '/api/ws-companies/admin/sales-units';
    const pathInternal = '/api/admin/sales-units';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesUnit !== undefined) {
        body = params.salesUnit;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSalesUnit.paramsOrder = [{ type: 'body', paramName: 'salesUnit' }];
export const getSalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    const path = '/api/ws-companies/admin/sales-units/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    const pathInternal = '/api/admin/sales-units/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesUnit.paramsOrder = [{ type: 'parameters' }];
export const updateSalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    if (params.salesUnit === undefined) {
        throw new Error('Missing required body: salesUnit');
    }
    const path = '/api/ws-companies/admin/sales-units/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    const pathInternal = '/api/admin/sales-units/{salesUnitId}'.replace('{salesUnitId}', params.salesUnitId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesUnit !== undefined) {
        body = params.salesUnit;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesUnit.paramsOrder = [{ type: 'body', paramName: 'salesUnit' }, { type: 'parameters' }];
export const findCompanyDefaultSalesUnit = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/admin/sales-units/default';
    const pathInternal = '/api/admin/sales-units/default';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCompanyDefaultSalesUnit.paramsOrder = [{ type: 'parameters' }];
export const getActiveSalesUnitsByCurrency = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.currency === undefined) {
        throw new Error('Missing required parameter: currency');
    }
    const path = '/api/ws-companies/admin/sales-units/by-currency/{currency}'.replace('{currency}', params.currency?.toString());
    const pathInternal = '/api/admin/sales-units/by-currency/{currency}'.replace('{currency}', params.currency?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getActiveSalesUnitsByCurrency.paramsOrder = [{ type: 'parameters' }];
export const getPdfSequencings = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/pdf-sequencings';
    const pathInternal = '/api/company/pdf-sequencings';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPdfSequencings.paramsOrder = [{ type: 'parameters' }];
export const updatePdfSequencing = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.pdfMediaTypeSequence === undefined) {
        throw new Error('Missing required body: pdfMediaTypeSequence');
    }
    const path = '/api/ws-companies/company/{type}/pdf-sequencings'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/{type}/pdf-sequencings'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    if (params.pdfMediaTypeSequence !== undefined) {
        body = params.pdfMediaTypeSequence;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePdfSequencing.paramsOrder = [
    { type: 'body', paramName: 'pdfMediaTypeSequence' },
    { type: 'parameters' },
];
export const getPdfMediaTypeSequence = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-companies/company/{type}/pdf-media-types-sequence'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/company/{type}/pdf-media-types-sequence'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesUnitId : (params.salesUnitId ?? queryDefaults?.['salesUnitId']);
        if (value !== undefined) {
            urlParams.append('salesUnitId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPdfMediaTypeSequence.paramsOrder = [{ type: 'parameters' }];
/** Upload ppt title file */ export const uploadPptTitleFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pptStyleId === undefined) {
        throw new Error('Missing required parameter: pptStyleId');
    }
    if (params.fileId === undefined) {
        throw new Error('Missing required parameter: fileId');
    }
    const path = '/api/ws-companies/ppt-titles/upload';
    const pathInternal = '/api/ppt-titles/upload';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.pptStyleId !== undefined) {
        urlParams.append('pptStyleId', params.pptStyleId.toString());
    }
    if (params.fileId !== undefined) {
        urlParams.append('fileId', params.fileId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
uploadPptTitleFile.paramsOrder = [{ type: 'parameters' }];
/** Delete ppt title file */ export const deletePptTitleFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pptStyleId === undefined) {
        throw new Error('Missing required parameter: pptStyleId');
    }
    const path = '/api/ws-companies/ppt-titles/{id}'.replace('{pptStyleId}', params.pptStyleId?.toString());
    const pathInternal = '/api/ppt-titles/{id}'.replace('{pptStyleId}', params.pptStyleId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deletePptTitleFile.paramsOrder = [{ type: 'parameters' }];
export const getHolidays = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.code === undefined) {
        throw new Error('Missing required parameter: code');
    }
    const path = '/api/ws-companies/holidays';
    const pathInternal = '/api/holidays';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.code !== undefined) {
        urlParams.append('code', params.code.toString());
    }
    {
        const value = queryDefaults === false ? params.year : (params.year ?? queryDefaults?.['year']);
        if (value !== undefined) {
            urlParams.append('year', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getHolidays.paramsOrder = [{ type: 'parameters' }];
export const generateTemporaryAccess = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/admin/companies/{companyId}/temporary-access/generate'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/admin/companies/{companyId}/temporary-access/generate'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
generateTemporaryAccess.paramsOrder = [{ type: 'parameters' }];
export const getTemporaryAccessPin = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/company/temporary-access/pin';
    const pathInternal = '/api/company/temporary-access/pin';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTemporaryAccessPin.paramsOrder = [];
export const verifyTemporaryAccessPin = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-companies/admin/companies/{companyId}/temporary-access/verify-pin'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/admin/companies/{companyId}/temporary-access/verify-pin'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
verifyTemporaryAccessPin.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getTemporaryAccessHistory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-companies/admin/temporary-access/history';
    const pathInternal = '/api/admin/temporary-access/history';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortDirection : (params.sortDirection ?? queryDefaults?.['sortDirection']);
        if (value !== undefined) {
            urlParams.append('sortDirection', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sortProperties : (params.sortProperties ?? queryDefaults?.['sortProperties']);
        if (value !== undefined) {
            urlParams.append('sortProperties', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTemporaryAccessHistory.paramsOrder = [{ type: 'parameters' }];
export const downloadAdminSessionLog = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-companies/admin/temporary-access/sessions/{id}/log'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/admin/temporary-access/sessions/{id}/log'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/csv';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadAdminSessionLog.paramsOrder = [{ type: 'parameters' }];
export const hasTemporaryAccess = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-companies/admin/companies/{companyId}/temporary-access/check'.replace('{companyId}', params.companyId?.toString());
    const pathInternal = '/api/admin/companies/{companyId}/temporary-access/check'.replace('{companyId}', params.companyId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
hasTemporaryAccess.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
